import RedirectHelper from '../../../../components/RedirectHelper';

const ForgotPassword = (): JSX.Element => {
  RedirectHelper.redirectToUserManagementWithRedirectSet('/forgot-password');
  return <></>;
};

export default ForgotPassword;
